import React from "react";
import Testimonial from "../../../common/testimonial/Testimonial";
import { testimonialSections } from "../../../utils/testimonials";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';

function MobileTestimonialsSection() {
  return (
    <section>
      <div className="mobile-testimonial-wrapper">
        <h2 className="testimonial-title text-center">
          <span
            className="bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-teal-400"
            style={{ color: "#6E4CD1" }}
          >
            Flexible{" "}
          </span>
          for everyone needs
        </h2>
        <div className="flex justify-center">
          <Carousel showThumbs={false} showArrows={false} showStatus={false} className="flex carusel-wrapper">
            {testimonialSections.map((section, index) => (
              <Testimonial
                key={index}
                section={section}
                isMobile
              />
            ))}
          </Carousel>
        </div>
      </div>
    </section>
  );
}

export default MobileTestimonialsSection;
